// extracted by mini-css-extract-plugin
export var closeButton = "_7s-0";